import { faPencilAlt } from '@fortawesome/pro-regular-svg-icons'
import {
  Box,
  Flex,
  ActionIcon,
  Popover,
  Button,
} from '@mantine/core'
import { useState, useEffect } from 'react'

import { useTranslation } from '@flecto/translations'
import { Icon, InputCurrency, TextCurrency } from '@flecto/ui'

export function EditableCurrencyValue({
  value,
  onChange,
  disabled,
}: {
  value: number
  onChange: (value: number) => void
  disabled: boolean
  }) {
  const { t: tActions } = useTranslation('shared', { keyPrefix: 'actions' })
  const [opened, setOpened] = useState(false)
  const [editValue, setEditValue] = useState(value)

  useEffect(() => {
    setEditValue(value)
  }, [value])

  const handleSave = () => {
    try {
      onChange(editValue)
    } finally {
      setOpened(false)
    }
  }

  return (
    <Box>
      <Popover
        opened={opened}
        onClose={() => setOpened(false)}
        position='top'
        shadow='md'
        withArrow
      >
        <Flex align='center' mt={-10}>
          <TextCurrency cents={value} />

          <Popover.Target>
            <Box>
              {!disabled && (
                <ActionIcon ml='xs' size='xs' onClick={() => setOpened(true)}>
                  <Icon icon={faPencilAlt} />
                </ActionIcon>
              )}
            </Box>
          </Popover.Target>
        </Flex>

        <Popover.Dropdown>
          <Flex direction='column' gap='md'>
            <InputCurrency
              value={editValue}
              onChange={(value) => setEditValue(value)}
              min={1}
            />
            <Flex gap='sm'>
              <Button
                variant='default'
                w='100%'
                onClick={() => setOpened(false)}
              >
                {tActions('cancel')}
              </Button>
              <Button onClick={handleSave} w='100%'>
                {tActions('confirm')}
              </Button>
            </Flex>
          </Flex>
        </Popover.Dropdown>
      </Popover>
    </Box>
  )
}
